import { render } from "./PerformanceMarketingSection.vue?vue&type=template&id=7f82db5e"
import script from "./PerformanceMarketingSection.vue?vue&type=script&lang=js"
export * from "./PerformanceMarketingSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__